module.exports = __webpack_public_path__ + "img/quest_icon_0077_magic4.1ae3cc7d.png";